import React, { useState, useEffect, lazy, Suspense } from 'react'
import { Grid, Button } from '@material-ui/core'
import './styles/viewForms.scss'
import { useHistory } from 'react-router-dom'
import ExitIcon from '@material-ui/icons/ExitToApp'
import ReactTooltip from 'react-tooltip'
import MenuItem from '@mui/material/MenuItem'
import { useForm } from '../../../../../context/formContext'
import Select from '@mui/material/Select'
import DeleteIcon from '@mui/icons-material/Delete'
import InputLabel from '@mui/material/InputLabel'
import FormControl from '@mui/material/FormControl'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { getListFormFilters } from '../../../../../services/Forms/get'
import DatePicker from 'react-datepicker'
import es from 'date-fns/locale/es'
import 'react-datepicker/dist/react-datepicker.css'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
const TableData = lazy(() => import('./CollapsibleTable'))

const ViewForms = () => {
  const {
    getForms,
    listForms,
    setFetchRequest,
    statesCodes,
    setListForms,
    ActualPage,
    pageSize,
    projectCode,
    stage,
    projectName,
    setActualPage,
    setPageSize,
    pagesCounter,
    setPagesCount,
  } = useForm()

  const history = useHistory()

  // filtro por estado
  const [statusFilter, setStatusFilter] = useState('')
  const [statusOrder, setStatusOrder] = useState(false)

  // comprueba si el boton filtrar ha sido accionado
  const [filtersOn, setFiltersOn] = useState(false)

  // filtro por codigo de proyecto
  const [projectCodeFilter, setprojectCodeFilter] = useState('')
  const [projectCodeFilterOn, setprojectCodeFilterOn] = useState(false)

  // filtro por etapa de proyecto
  const [projectStage, setprojectStage] = useState('')
  const [projectStageFilterOn, setprojectStageFilterOn] = useState(false)

  // filtro por nombre de proyecto
  const [projectsName, setprojectsName] = useState('')
  const [projectsNameFilterOn, setprojectsNameFilterOn] = useState(false)

  // filtro por  fecha
  const [startDate, setStartDate] = useState('')
  const [dateFilterOn, setdateFilterOn] = useState(false)

  const cancelForm = () => {
    history.push('/')
  }

  const handleState = (e) => {
    setStatusFilter(e)
    setStatusOrder(true)
  }

  const handleProjectCode = (e) => {
    setprojectCodeFilter(e)
    setprojectCodeFilterOn(true)
  }

  const handleProjectStage = (e) => {
    setprojectStage(e)
    setprojectStageFilterOn(true)
  }

  const handleProjectName = (e) => {
    setprojectsName(e)
    setprojectsNameFilterOn(true)
  }

  const handleDate = (e) => {
    setStartDate(e)
    setdateFilterOn(true)
  }

  const [cleanFilters, setCleanFilters] = useState(false)

  const limpiarFiltros = () => {
    setStatusFilter('')
    setStatusOrder(false)
    setprojectStage('')
    setprojectStageFilterOn(false)
    setprojectCodeFilter('')
    setprojectCodeFilterOn(false)
    setprojectsName('')
    setprojectsNameFilterOn(false)
    setStartDate('')
    setdateFilterOn(false)
    setActualPage(1)
    setPageSize(10)
    setCleanFilters(true)
  }

  useEffect(() => {
    if (cleanFilters) {
      getForms()
      setCleanFilters(false)
    } else {
      setCleanFilters(false)
    }
  }, [cleanFilters])

  const getFiltersForms = async () => {
    setListForms({ loading: true, list: [] })

    let localDate = ''

    if (startDate !== '' && startDate !== undefined && startDate !== null) {
      localDate = new Date(startDate).toLocaleDateString()
    }

    await getListFormFilters(
      'mipyme',
      ActualPage,
      pageSize,
      statusFilter,
      statusOrder,
      projectCodeFilter,
      projectCodeFilterOn,
      projectStage,
      projectStageFilterOn,
      projectsName,
      projectsNameFilterOn,
      localDate,
      dateFilterOn,
    )
      .then((res) => {
        const count = pagesCounter(res?.pagination.totalRecords, pageSize)
        setPagesCount(count)
        setListForms({ loading: false, list: res.formsPreElegibility })
        listado(res.formsPreElegibility)
      })
      .catch((err) => {
        console.log(err)
        setListForms({ loading: false, list: [] })
      })
  }

  /* useEffect(() => {
    if (filtersOn) {
      getFiltersForms()
      setFiltersOn(false)
    }
  }, [filtersOn, statusFilter]) */

  useEffect(() => {
    if (filtersOn && ActualPage !== 1) {
      setActualPage(1)
    }
    if (filtersOn) {
      getFiltersForms()
      setFiltersOn(false)
    }
  }, [filtersOn, ActualPage])

  const [rows, setRows] = useState()

  const formatDate = (str) => {
    const date = new Date(str)
    return date.toLocaleDateString()
  }

  const listado = (list) => {
    const updateRow = []

    list.map((item) =>
      updateRow.push({
        idFormType: item.idFormType,
        dateCreated: formatDate(item.dateCreated),
        miPymeBusinessName: item.miPymeBusinessName,
        countryLargeName: item.countryLargeName,
        ifiFullName: item.ifiFullName,
        idFormStatus: item.idFormStatus,
        formStatusDescription: item.formStatusDescription,
        formsPreElegibilityHistoryDto: item.formsPreElegibilityHistoryDto,
        miPymeIdentification: item.miPymeIdentification,
        miPymeDepartment: item.miPymeDepartment,
        miPymeMunicipality: item.miPymeMunicipality,
        miPymePhone: item.miPymePhone,
        miPymeAdress: item.miPymeAdress,
        legalRepresentativeFullName: item.legalRepresentativeFullName,
        identificationLegalRepresentative:
          item.identificationLegalRepresentative,
        stage: item.stage,
      }),
    )

    setRows(updateRow)
  }

  useEffect(() => {
    setFetchRequest(['view_form'])
  }, [])

  useEffect(() => {
    if (listForms.list && listForms.list.length > 0) {
      listado(listForms.list)
    } else {
      listado([])
    }
  }, [listForms])

  const testDivRef = React.useRef(null)

  const scrollTop = () => {
    testDivRef.current.scrollIntoView()
  }

  useEffect(() => {
    if (listForms.loading) {
      scrollTop()
    }
  }, [listForms.loading])

  return (
    <Grid
      container
      style={{
        width: '100%',
        height: 'auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px',
      }}
      ref={testDivRef}
    >
      <div
        style={{
          height: 'auto',
          width: '96%',
          backgroundColor: '#fff',
          borderRadius: '4px',
          marginTop: '10px',
        }}
      >
        <Grid container md={12} sm={12}>
          <div className="tableTitle">
            <Grid item md={12} xs={12} style={{ padding: '20px' }}>
              <h1
                style={{
                  fontSize: '30px',
                  fontWeight: '900',
                  color: '#111',
                }}
              >
                Consulta De Formularios
              </h1>
              <p style={{ paddingLeft: '3px', paddingTop: '5px' }}>
                Visualice los formularios enviados
              </p>
              <div className="options">
                <div
                  data-tip
                  data-for="exitPop"
                  style={{
                    backgroundColor: 'red',
                    color: '#fff',
                    width: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '4px',
                    padding: '5px',
                    cursor: 'pointer',
                  }}
                  onClick={() => cancelForm()}
                >
                  <ExitIcon style={{ transform: 'scaleX(-1)' }} />
                  <ReactTooltip
                    id="exitPop"
                    effect="solid"
                    backgroundColor="red"
                  >
                    <span>Regresar</span>
                  </ReactTooltip>
                </div>

                {/* <Button
                  data-tip
                  data-for="exportPop"
                  id="basic-button"
                  aria-controls={open ? 'basic-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? 'true' : undefined}
                  onClick={handleClick}
                  style={{
                    backgroundColor: '#26be80',
                    color: '#fff',
                    width: 'auto',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '4px',
                    padding: '10px',
                    cursor: 'pointer',
                    marginLeft: '16px',
                  }}
                >
                  Exportar
                  <FileDownloadIcon
                    style={{
                      color: '#fff',
                      marginLeft: '5px',
                    }}
                  />
                </Button>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    'aria-labelledby': 'basic-button',
                  }}
                >
                  <MenuItem onClick={handleClose}>Exportar PDF</MenuItem>
                  <MenuItem onClick={handleClose}>Exportar Excel</MenuItem>
                </Menu>
                <ReactTooltip
                  id="exportPop"
                  effect="solid"
                  backgroundColor="#25bc81"
                >
                  <span>Exportar PDF o Excel</span>
                </ReactTooltip> */}

                {listForms.loading ? (
                  <Button
                    data-tip
                    data-for="cleanFilters"
                    id="basic-button"
                    aria-haspopup="true"
                    className="buttonOptionsDisabled"
                    disabled={true}
                  >
                    <span>Limpiar Filtros</span>
                    <DeleteIcon
                      style={{
                        color: '#fff',
                        marginLeft: '5px',
                      }}
                    />
                  </Button>
                ) : (
                  <Button
                    data-tip
                    data-for="cleanFilters"
                    id="basic-button"
                    aria-haspopup="true"
                    className="buttonOptions"
                    onClick={(e) => limpiarFiltros()}
                  >
                    <span>Limpiar Filtros</span>
                    <DeleteIcon
                      style={{
                        color: '#fff',
                        marginLeft: '5px',
                      }}
                    />
                  </Button>
                )}
                <ReactTooltip
                  id="cleanFilters"
                  effect="solid"
                  backgroundColor="#0d53ad"
                >
                  <span>Limpiar filtros seleccionados</span>
                </ReactTooltip>
                {listForms.loading ? (
                  <Button
                    data-tip
                    data-for="filters"
                    id="basic-button"
                    aria-haspopup="true"
                    className="buttonOptionsDisabled breakButton"
                    disabled={true}
                  >
                    Filtrar
                    <FilterAltIcon />
                  </Button>
                ) : (
                  <Button
                    data-tip
                    data-for="filters"
                    id="basic-button"
                    aria-haspopup="true"
                    className="buttonOptions breakButton"
                    onClick={() => setFiltersOn(true)}
                  >
                    Filtrar
                    <FilterAltIcon />
                  </Button>
                )}

                <ReactTooltip
                  id="filters"
                  effect="solid"
                  backgroundColor="#0d53ad"
                >
                  <span>Búsqueda por filtros seleccionados</span>
                </ReactTooltip>
              </div>
            </Grid>
          </div>
          <Grid md={12} sm={12} xs={12}>
            <div className="tableOptions">
              <Grid md={12} sm={12} xs={12} style={{ marginBottom: '10px' }}>
                <div className="tableFilters">
                  <Grid
                    md={4}
                    sm={4}
                    xs={12}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '10px',
                    }}
                  >
                    <Grid item md={11} sm={11} xs={11}>
                      <FormControl fullWidth>
                        <DatePicker
                          selected={startDate}
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dateFormat="dd/MM/yyyy"
                          dropdownMode="select"
                          locale={es}
                          placeholderText="Fecha"
                          onChangeRaw={(e) => e.preventDefault()}
                          onChange={(date) => handleDate(date)}
                          disabled={listForms.loading}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Grid
                    md={4}
                    sm={4}
                    xs={12}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '10px',
                    }}
                  >
                    <Grid item md={11} sm={11} xs={11}>
                      <FormControl fullWidth disabled={listForms.loading}>
                        <InputLabel className="reduceText">
                          Código Proyecto
                        </InputLabel>
                        <Select
                          id="CodigoProyecto"
                          label="Código Proyecto"
                          value={projectCodeFilter}
                          onChange={(e) => {
                            handleProjectCode(e.target.value)
                          }}
                        >
                          <MenuItem value={''}>Seleccione una opción</MenuItem>
                          {projectCode &&
                            projectCode.map((item, key) => (
                              <MenuItem key={key} value={item}>
                                {item}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Grid
                    md={4}
                    sm={4}
                    xs={12}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '10px',
                    }}
                    className="spacingFilter"
                  >
                    <Grid md={11} sm={11} xs={11}>
                      <FormControl fullWidth disabled={listForms.loading}>
                        <InputLabel>Nombre Proyecto</InputLabel>
                        <Select
                          id="NombreProyecto"
                          label="Nombre Proyecto"
                          value={projectsName}
                          onChange={(e) => {
                            handleProjectName(e.target.value)
                          }}
                        >
                          <MenuItem value={''}>Seleccione una opción</MenuItem>
                          {projectName &&
                            projectName.map((item, key) => (
                              <MenuItem key={key} value={item}>
                                {item}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </div>
              </Grid>
              <Grid md={12} sm={12} xs={12}>
                <div className="tableFilters">
                  <Grid
                    md={4}
                    sm={4}
                    xs={12}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '10px',
                    }}
                  >
                    <Grid md={11} sm={11} xs={11}>
                      <FormControl disabled fullWidth>
                        <InputLabel>IFI</InputLabel>
                        <Select id="departmentName" label="IFI">
                          <MenuItem value={''}>Seleccione una opción</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Grid
                    md={4}
                    sm={4}
                    xs={12}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '10px',
                    }}
                  >
                    <Grid md={11} sm={11} xs={11}>
                      <FormControl fullWidth disabled={listForms.loading}>
                        <InputLabel>Etapa</InputLabel>
                        <Select
                          id=""
                          label="Etapa"
                          value={projectStage}
                          onChange={(e) => {
                            handleProjectStage(e.target.value)
                          }}
                        >
                          <MenuItem value={''}>Seleccione una opción</MenuItem>
                          {stage &&
                            stage.map((item, key) => (
                              <MenuItem key={key} value={item.description}>
                                {item.description}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Grid
                    md={4}
                    sm={4}
                    xs={12}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '10px',
                    }}
                    className="spacingFilter"
                  >
                    <Grid md={11} sm={11} xs={11}>
                      <FormControl fullWidth disabled={listForms.loading}>
                        <InputLabel>Estados</InputLabel>
                        <Select
                          id="departmentName"
                          label="Estados"
                          value={statusFilter}
                          onChange={(e) => {
                            handleState(e.target.value)
                          }}
                        >
                          <MenuItem value={''}>Seleccione una opción</MenuItem>
                          {statesCodes &&
                            statesCodes.map((item, key) => (
                              <MenuItem key={item.id} value={item.id}>
                                {item.value}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </div>
              </Grid>
            </div>
          </Grid>
        </Grid>
        <div className="tableData">
          <Suspense
            fallback={
              <div
                style={{
                  display: 'flex',
                  width: '100%',
                  height: '40vh',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Box
                  style={{
                    marginTop: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <CircularProgress />
                </Box>
              </div>
            }
          >
            <TableData
              rows={rows}
              loading={listForms.loading}
              getFiltersForms={getFiltersForms}
            />
          </Suspense>
        </div>
      </div>
    </Grid>
  )
}

export default React.memo(ViewForms)
